import { ESBitbucketAssociatedRepository } from '../../models/git-repository';
import { Action } from '../../../../ngrx/actions/unsafe-action';

export const CREATE = '[bitbucket-associated-repository.actions] CREATE';
export const UPDATED = '[bitbucket-associated-repository.actions] UPDATED GITHUB REPOSITORYS';
export const GET_INDEX = '[bitbucket-associated-repository.actions] GET_INDEX';
export const GET_INDEX_COMPLETE = '[bitbucket-associated-repository.actions] GET_INDEX_COMPLETE';
export const REMOVE = '[bitbucket-associated-repository.actions] REMOVE';
export const GET_INDEX_FAIL = '[bitbucket-associated-repository.actions] GET_INDEX_FAIL';

export class GetIndex implements Action {
  readonly type = GET_INDEX;
}

export class Updated implements Action {
  readonly type = UPDATED;

  constructor(public payload: ESBitbucketAssociatedRepository) {}
}

export class GetIndexComplete implements Action {
  readonly type = GET_INDEX_COMPLETE;

  constructor(public payload: ESBitbucketAssociatedRepository) {}
}

export class GetIndexFail implements Action {
  readonly type = GET_INDEX_FAIL;

  constructor(public payload?: any) {}
}

export class Remove implements Action {
  readonly type = REMOVE;

  constructor(public payload: { id: number }) {}
}

export class Create implements Action {
  readonly type = CREATE;

  constructor(public payload: { repositoryId: string; repositoryName: string; bitbucketCompany: number }) {}
}

// prettier-ignore
export type Actions
  = GetIndex
  | Updated
  | GetIndexComplete
  | GetIndexFail
  | Remove
  | Create
  ;
